import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  AddTask,
  ClearTasks,
  Retry,
  CompleteTask,
  ErrorTask,
  RemoveTask,
  StartTask,
} from './tasks.actions';
import { ITasksState } from './tasks.interface';
import { append, patch, removeItem, updateItem } from '@ngxs/store/operators';

@State<ITasksState>({
  name: 'tasks',
  defaults: {
    currentFilename: '',
    tasks: [],
    canRetry: false,
    resume: false,
  },
})
@Injectable()
export class TasksState {
  @Action(AddTask)
  setOrder(ctx: StateContext<ITasksState>, { payload }: AddTask) {
    payload.uploading = true;
    ctx.setState(
      patch({
        resume: true,
        tasks: append([payload]),
      })
    );
  }

  @Action(CompleteTask)
  complete(ctx: StateContext<ITasksState>, { payload }: CompleteTask) {
    const taskUpdated = { completed: true, current: 100, uploading: false };
    ctx.setState(
      patch({
        currentFilename: '',
        resume: true,
        tasks: updateItem((item) => item.name === payload.name, patch(taskUpdated)),
      })
    );
  }

  @Action(ClearTasks)
  clearTasks(ctx: StateContext<ITasksState>) {
    ctx.setState(
      patch({
        tasks: [],
      })
    );
  }

  @Action(StartTask)
  start(ctx: StateContext<ITasksState>) {
    ctx.setState(
      patch({
        resume: false,
      })
    );
  }

  @Action(Retry)
  resume(ctx: StateContext<ITasksState>, { payload }: Retry) {
    const taskUpdated = { uploading: false };
    ctx.patchState({
      currentFilename: '',
    });
    ctx.setState(
      patch({
        resume: true,
        canRetry: false,
        currentFilename: payload,
        tasks: updateItem((item) => item.name === payload, patch(taskUpdated)),
      })
    );
  }

  @Action(ErrorTask)
  errorTask(ctx: StateContext<ITasksState>, { payload }: CompleteTask) {
    const taskUpdated = { canRetry: true, current: 0, resume: false, uploading: false };
    ctx.setState(
      patch({
        resume: false,
        canRetry: true,
        tasks: updateItem((item) => item.name === payload.name, patch(taskUpdated)),
      })
    );
  }

  @Action(RemoveTask)
  remove(ctx: StateContext<ITasksState>, { taskName }: RemoveTask) {
    const currentFilename = ctx.getState().currentFilename;
    ctx.setState(
      patch({
        currentFilename: taskName === currentFilename ? '' : currentFilename,
        resume: false,
        tasks: removeItem((item) => item.name === taskName),
      })
    );
  }
}
